import React from 'react';
import { ArrowRight } from 'lucide-react';
import '../choose.css';

const reasons = [
    {
    title: "Personalized Approach",
    description: "Every project is unique. We tailor our services to match your specific needs, preferences, and budget."
    },
    {
    title: "Quality Craftsmanship",
    description: "Our team of skilled professionals delivers exceptional quality in every aspect of construction and design."
    },
    {
    title: "Transparent Communication",
    description: "Stay informed throughout the process with regular updates, clear timelines, and open dialogue."
    }
];

const WhyChooseUs = () => {
    return (
    <section className="why-choose-container">
      {/* Cards Section */}
        <div className="why-header">
        <h2>Why Choose Our Services?</h2>
        <p>Experience the difference of working with dedicated professionals</p>
        </div>

        <div className="reasons-grid">
        {reasons.map((item, index) => (
            <div key={index} className="reason-card">
            <div className="reason-icon-circle">
                <div className="inner-dot"></div>
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            </div>
        ))}
        </div>

      {/* Blue Banner CTA Section */}
        <div className="banner-cta">
        <div className="banner-content">
            <h2>Ready to Start Your Project?</h2>
            <p>Let's discuss how we can bring your vision to life with our expert services.</p>
            <a href='/portfolio'><button className="banner-button">
            Get Started <ArrowRight size={18} />
            </button></a>
        </div>
        {/* Decorative background shapes */}
        <div className="banner-shape shape-left"></div>
        <div className="banner-shape shape-right"></div>
        </div>
    </section>
    );
};

export default WhyChooseUs;